import apiClient from '../../../shared/config/axios'
import { TechnicianProfile, UpdateTechnicianCalendarOrderDto } from '@myapp/contract'

export const technicianProfileApi = {
  /** Active profiles only — the API filters with `onlyActive: true`. */
  list: () => apiClient.get<TechnicianProfile[]>('/technician-profiles'),

  /** DIRECTOR / SUPERUSER only. The array order is the order; `hidden` greys the row out. */
  updateCalendarOrder: (dto: UpdateTechnicianCalendarOrderDto) =>
    apiClient.put<void>('/technician-profiles/calendar-order', dto),
}
